import React, { useEffect, useState } from "react";
import apiClient from '../../acciones/apiClient';
import "./perfilFami.css";
import { NavBar } from "../../componentes/navbar";
import { useParams } from "react-router-dom";
import { ImgCabecera } from '../../componentes/imgCabecera/imgCabe';
import AdSenseComponent from '../../componentes/adSense/adSenseComponent';

export const PerfilFamiCar = () => {
    const { id } = useParams(); // Obtener el ID desde la URL
    const [perfil, setPerfil] = useState(null);

    useEffect(() => {
        const fetchPerfil = async () => {
            try {
                const response = await apiClient.get(`/usuarios/perfil/${id}`);
                console.log("Perfil recibido:", response.data); // Depura aquí
                setPerfil(response.data);
            } catch (error) {
                console.error("Error al obtener el perfil:", error);
            }
        };
        fetchPerfil();
    }, [id]);

    if (!perfil) {
        return <p>Cargando perfil...</p>;
    }

    // Verificar si `tablon` existe y dividirlo en líneas si es necesario
    const publicacionesTablon = perfil?.tablon
        ? perfil.tablon.split("\n").filter((linea) => linea.trim() !== "") // Filtrar líneas vacías
        : [];


    return (
        <div>
            <ImgCabecera />
            <NavBar />

            <div className="perfilFamiContainer">
                <div className="perfilFamiCartel">
                    <img
                        src={perfil.imagen_perfil || "/front/src/img/imgPerfil.webp"} // Imagen predeterminada si no hay imagen
                        alt={perfil.nombre_usuario}
                        onError={(e) => {
                            e.target.src = "/front/src/img/imgPerfil.webp"; // Imagen predeterminada si falla la carga
                        }}
                    />
                </div>
                <div className="nameInfoPerfilFamiCar">
                    <h1>{perfil.nombre_usuario}</h1>
                    <p>{perfil.descripcion || "Sin descripción disponible"}</p>
                </div>
            </div>
                        <div style={{ margin: '1rem 0' }}>
                <AdSenseComponent />
            </div>
            <div className="tablonPerfilFami">
                <h2>Tablón</h2>
                {publicacionesTablon.length > 0 ? (
                    publicacionesTablon.map((publicacion, index) => (
                        <div key={index} className="tablonEscribir">
                            <p>{publicacion}</p>
                        </div>
                    ))
                ) : (
                    <p>No hay publicaciones en el tablón.</p>
                )}
            </div>
<div style={{ margin: '1rem 0' }}>
                <AdSenseComponent />
            </div>
            <div className="ultimosProyectosPerfilFami"> {/* nuevo */}
                <h2>Últimos Proyectos</h2>
                {perfil.proyectos && perfil.proyectos.length > 0 ? (
                    perfil.proyectos.map((proyecto, index) => (
                        <div className="cardPerfilUsu">
                            <a href={`/InfoProyectos/${proyecto.proyecto_id}`}>
                                <img
                                    src={proyecto.portada}
                                    alt={`Portada de ${proyecto.titulo}`}
                                    className="imgPortada"
                                />
                            </a>

                            <h5>{proyecto.titulo}</h5>
                        </div>
                    ))
                ) : (
                    <p>No hay proyectos disponibles.</p>
                )}
            </div>

        </div>
    )
}